export default "__VITE_ASSET__BzSH5MkA__"